<script>
import { useAlert } from 'dashboard/composables';
export default{
    name: "ConfirmCancelModal",
    props: {
        deleteName: {
            type: String,
            required: true
        }
    },
    emits: ['confirm-delete', 'close']
}
</script>

<template>
    <div class="fixed inset-0 flex items-center justify-center bg-slate-800/50 px-4">
        <div class="p-6 border-2 rounded-lg bg-white dark:bg-slate-800 shadow-xl max-w-sm w-full">            
            <h1 class="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-3">
                Confirm Cancellation
            </h1>
            <p class="text-sm text-gray-700 dark:text-gray-300 mb-6">
                Are you sure you want to cancel <strong>{{ deleteName }}</strong>?
            </p>
            <div class="flex justify-end space-x-2">
                <woot-button
                    variant="smooth"
                    color-scheme="secondary"
                    icon="cancel"
                    @click="$emit('close')"
                >
                    Cancel
                </woot-button>
                <woot-button
                    variant="smooth"
                    color-scheme="alert"
                    icon="delete"
                    @click="$emit('confirm-delete')"
                >
                    Confirm Cancellation
                </woot-button>
            </div>
        </div>
    </div>
</template>
